module.exports = __webpack_public_path__ + "static/media/cricket.225c8ba8.svg";